export function normalizeWebSocketLogs(wsData) {
  if (Array.isArray(wsData?.logs)) {
    return wsData.logs.map((entry) => ({
      ...flattenLogEntry({
        mysql_id: entry.id ?? entry.mysql_id,
        ...entry.log,
      }),
      source: "websocket",
    }));
  }

  if (wsData?.log && wsData?.id) {
    return [
      {
        ...flattenLogEntry({
          mysql_id: wsData.id,
          ...wsData.log,
        }),
        source: "websocket",
      },
    ];
  }

  // Support raw log array
  if (Array.isArray(wsData)) {
    return wsData.map((entry) => ({
      ...flattenLogEntry({
        mysql_id: entry.id ?? entry.mysql_id,
        ...entry.log,
      }),
      source: "websocket",
    }));
  }

  console.warn("🛑 Unsupported WebSocket log format:", wsData);
  return [];
}

export function normalizeApiLogs(apiResponse) {
  const rawLogs = Array.isArray(apiResponse)
    ? apiResponse
    : (apiResponse?.data ?? []);

  return rawLogs.map((entry) => {
    const { id, mysql_id, ...rest } = entry;
    const flat = flattenLogEntry({
      mysql_id: mysql_id ?? id,
      ...rest,
    });
    return { ...flat, source: "api" };
  });
}

function flattenLogEntry(entry) {
  const time = entry._time || entry.gw_time_parsed || entry.gw_time || null;

  return {
    id: entry.mysql_id ?? entry.id ?? null,
    device_id: entry.device_id ?? "",
    gw_time_parsed: time ? new Date(time).toISOString() : null,

    system_voltage: entry.system_voltage ?? null,
    dev_fw: entry.dev_fw ?? null,
    ovp_counter: entry.ovp_counter ?? null,

    // Valve 1
    v1_set_pressure: entry.v1_set_pressure ?? null,
    v1_reset_pressure: entry.v1_reset_pressure ?? null,
    v1_ind_pressure: entry.v1_ind_pressure ?? null,
    v1_hyd_pressure: entry.v1_hyd_pressure ?? null,
    v1_valve_state: entry.v1_valve_state ?? null,
    v1_stat_1: entry.v1_stat_1 ?? null,
    v1_stat_2: entry.v1_stat_2 ?? null,
    v1_avg_line_pressure: entry.v1_avg_line_pressure ?? null,
    V1pos1: entry.V1pos1 ?? null,
    V1pos2: entry.V1pos2 ?? null,

    // Valve 2
    v2_set_pressure: entry.v2_set_pressure ?? null,
    v2_reset_pressure: entry.v2_reset_pressure ?? null,
    v2_ind_pressure: entry.v2_ind_pressure ?? null,
    v2_hyd_pressure: entry.v2_hyd_pressure ?? null,
    v2_stat_1: entry.v2_stat_1 ?? null,
    v2_stat_2: entry.v2_stat_2 ?? null,
    v2_avg_line_pressure: entry.v2_avg_line_pressure ?? null,
    V2pos1: entry.V2pos1 ?? null,
    V2pos2: entry.V2pos2 ?? null,

    // Alarms and extras
    alarm_fault_1: entry.alarm_fault_1 ?? null,
    alarm_fault_2: entry.alarm_fault_2 ?? null,
    R_219: entry.R_219 ?? null,
  };
}
